// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kvdQ","index":"styles_index__3gP-Z"};